/* eslint-disable */
export const getObjectByKey = (obj, key) => {
  if (obj.hasOwnProperty(key)) {
    return obj[key];
  }
  return null;
};
